// component name
$component: 'zr-bannerx-slider';

@use '../zr-theme/zr-variables.scss' as *;

.#{$component}__wrapper {
    overflow-x: scroll;

    @media only screen and (min-width: $tablet-screen) {
        border-radius: 0 0 6px 6px;
    }

    .#{$component}__slider {
        left: 0;
        padding: 8px 8px 8px 0;
        position: relative;
        transition: left 200ms ease-in-out;
        display: flex;
        flex-wrap: nowrap;
        gap: 0;

        @media only screen and (min-width: $tablet-screen) {
            padding-bottom: 20px;
        }
    }
}

zr-product-tile {
    padding: 0 10px;
    min-width: 300px;

    @media only screen and (min-width: $tablet-screen) {
        min-width: 282px;
        border: none;
    }
}

zr-product-tile::part(tile) {
    border-left: solid 1px var(--ci-neutral200);
    border-right: solid 1px var(--ci-neutral200);
    box-shadow: 0 5px 15px var(--ci-neutral400);
    border-radius: 8px;
}

zr-product-tile::part(rating) {
    min-height: 24px;
    display: block;

    @media only screen and (min-width: $tablet-screen) {
        min-height: auto;
    }
}

